import { useTranslation } from 'react-i18next';
import type { DocAvailability } from '@shared/content-schemas';

/** "In development" / "Not yet available" on every docs article. Words first; color only repeats them. */
export function AvailabilityBadge({ availability }: { availability: DocAvailability }) {
  const { t } = useTranslation();
  const unavailable = availability === 'not-yet-available';
  return (
    <span className={`badge ${unavailable ? 'badge-planned' : 'badge-development'}`}>
      <span aria-hidden="true" className="badge-icon">
        {unavailable ? '○' : '◐'}
      </span>
      {t(`docs.availability.${availability}`)}
    </span>
  );
}
